import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Button } from 'semantic-ui-react';

import '../css/GoogleClassroomConnectionLauncherButton.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { DIALOG_NAMES } from '../managers/DialogManager';
import GoogleClassroomService from '../services/GoogleClassroomService';

import { scrollBrowserWindowToTop } from '../utils';

const GoogleClassroomConnectionLauncherButton = observer((props) => {
  const {
    classroom,
    t
  } = props;

  const {
    dialogManager
  } = useContext(MobXProviderContext);

  const InfoIcon = SatCoreComponent('InfoIcon');

  const handleLaunchGoogleClassroomConnectionModalIfAuthorized = async () => {
    // TODO remove // scrollBrowserWindowToTop();
    const hasAuthorization = await GoogleClassroomService.hasGoogleClassroomAuthorization();
    if (!hasAuthorization) {
      const authSuccess = await GoogleClassroomService.openGoogleClassroomAuthorizerWindow();
      if (!authSuccess) {
        return;
      }
    }
    scrollBrowserWindowToTop();

    const isLinkedGoogleClassroom = !!classroom?.googleClassroomId;

    dialogManager.setOpenDialog(DIALOG_NAMES.GOOGLE_CLASSROOM_CONNECTION_MODAL, {
      buttonKeyConfirmLabel: isLinkedGoogleClassroom ? 'unlink' : 'link',
      currentClassroom: classroom,
      fetchClassroomData: props.fetchClassroomData,
      handleNavigationClick: props.handleNavigationClick,
      onClose: () => {
        dialogManager.closeDialog(DIALOG_NAMES.GOOGLE_CLASSROOM_CONNECTION_MODAL);
      },
      onOpen: () => {
        // placeholder
      }
    }/* , () => {} */);
    // }, 100);
  };

  const renderGoogleClassroomConnectionLauncherButton = () => {
    const hasGoogleClassroomId = !!classroom.googleClassroomId;

    const launcherButtonLabel = hasGoogleClassroomId ? t('hasGoogleClassroomId') : t('needsGoogleClassroomId');

    const tooltipLauncherButtonLabel = hasGoogleClassroomId ? t('tooltipGoogleEnabled') : t('tooltipGoogleConnect');

    return (
      <>
        <div className='GoogleClassroomConnectionLauncherButton'>
          <div className='google-classroom-connection-btn-wrapper'>
            <Button aria-label={launcherButtonLabel}
              onClick={() => handleLaunchGoogleClassroomConnectionModalIfAuthorized()}>
              {launcherButtonLabel}
            </Button>
          </div>
        </div>
        {!!tooltipLauncherButtonLabel && (
          <div className='info-icon-parent-GoogleClassroomConnectionLauncherButton'>
            <InfoIcon className='InfoIcon-GoogleClassroomConnectionLauncherButton'
              popupOptions={{ content: tooltipLauncherButtonLabel, on: 'click' }} useWhiteInfoIcon={false} />
          </div>
        )}
      </>
    );
  };

  return renderGoogleClassroomConnectionLauncherButton();
});
export default GoogleClassroomConnectionLauncherButton;

SatCoreRegister('GoogleClassroomConnectionLauncherButton', GoogleClassroomConnectionLauncherButton);
